import { ChipPicker } from "./ChipPicker";
import type { ChipOption } from "./ChipPicker";
import type { Tag } from "../data/types";

/** Tags bucketed by group, keeping list order; the empty group sorts last. */
export function groupTags(tags: Tag[]): [string, Tag[]][] {
  const groups = [...new Set(tags.map((t) => t.group))].sort((a, b) => (a === "" ? 1 : b === "" ? -1 : 0));
  return groups.map((g) => [g, tags.filter((t) => t.group === g)]);
}

/**
 * The selected tags as chips, plus a select to add one more. Hidden tags are
 * never offered; one already on the request still shows (and can be removed),
 * so retiring a tag never strands a request. Same control on the New request
 * dialog and the detail panel.
 */
export function TagPicker({
  id,
  tags,
  value,
  onChange,
  disabled,
}: {
  id: string;
  /** Every tag; the picker filters hidden ones itself. */
  tags: Tag[];
  /** Selected tag ids. */
  value: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}) {
  const options: ChipOption[] = tags.map((t) => ({ id: t.id, name: t.name, group: t.group, selectable: !t.hidden }));

  return (
    <ChipPicker
      id={id}
      options={options}
      value={value}
      onChange={onChange}
      disabled={disabled}
      addLabel="Add tag"
      removeLabel={(name) => `Remove tag ${name}`}
      placeholder="Add a tag…"
      emptyLabel="No more tags to add"
    />
  );
}
